var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRxListingIconActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#193560",
    fillRule: "evenodd",
    d: "M3.5 15a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm17 0a1.5 1.5 0 0 1 0 3h-11a1.5 1.5 0 0 1 0-3h11zm-17-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm17 0a1.5 1.5 0 0 1 0 3h-11a1.5 1.5 0 0 1 0-3h11zm-17-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm17 0a1.5 1.5 0 0 1 0 3h-11a1.5 1.5 0 0 1 0-3h11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxListingIconActive);
export default __webpack_public_path__ + "static/media/rx-listing-icon-active.c05af5d3d4efcb95fd5c7fe2054bdfa1.svg";
export { ForwardRef as ReactComponent };